import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=c65136e0&scoped=true&"
import script from "./Roulette.vue?vue&type=script&lang=ts&"
export * from "./Roulette.vue?vue&type=script&lang=ts&"
import style0 from "./Roulette.vue?vue&type=style&index=0&id=c65136e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65136e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VLayout,VRow})
